import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

const BusinessDetailSkeleton = () => {
  return (
    <Card className="w-[100%] slg:w-[50%] sxl:max-w-xs animate-pulse">
      <CardHeader>
        <div className="h-6 bg-gray-300 rounded w-32 mb-2"></div>
        <Separator />
      </CardHeader>
      <CardContent className="flex flex-row gap-6 sxl:flex-col">
        <div className="flex items-center gap-4">
          <Avatar className="h-10 w-10 !rounded-lg bg-gray-300">
            <AvatarFallback className="bg-gray-400">--</AvatarFallback>
          </Avatar>
          <div className="grid gap-2 w-full">
            <div className="h-4 bg-gray-300 rounded w-24"></div>
            <div className="h-3 bg-gray-300 rounded w-16"></div>
          </div>
        </div>
        <div className="grid gap-4 w-full">
          <div className="grid gap-2">
            <div className="flex items-center gap-2">
              <div className="h-4 w-4 bg-gray-300 rounded"></div>
              <div className="h-3 bg-gray-300 rounded w-32"></div>
            </div>
            <div className="flex items-center gap-2">
              <div className="h-4 w-4 bg-gray-300 rounded"></div>
              <div className="h-3 bg-gray-300 rounded w-32"></div>
            </div>
            <div className="flex items-center gap-2">
              <div className="h-4 w-4 bg-gray-300 rounded"></div>
              <div className="h-3 bg-gray-300 rounded w-32"></div>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default BusinessDetailSkeleton;
